module.exports = "img/flags/ER.98c02cd.png";